import HTTPService from '@/api/http/HTTPService'

export default {
  getAll: () => HTTPService.get('file'),
  upload: (file: File) => HTTPService.file('file', file),
  getOne: (fileKey: string) => HTTPService.get(`file/${fileKey}`),
  delete: (fileKey: string) => HTTPService.delete(`file/${fileKey}`),
}
